/**
 * Social media buttons component for company links
 */

import React from 'react';
import { LinkedinLogo, FacebookLogo, InstagramLogo, YoutubeLogo, TiktokLogo } from '@phosphor-icons/react';
import { trackCompanyLink } from '../../../../../utils/analytics/analytics';

interface SocialMediaButtonsProps {
  linkedinUrl?: string;
  facebookUrl?: string;
  instagramUrl?: string;
  youtubeUrl?: string;
  tiktokUrl?: string;
  className?: string;
  companyId?: string | null;
  locale?: string;
}

export const SocialMediaButtons: React.FC<SocialMediaButtonsProps> = ({
  linkedinUrl,
  facebookUrl,
  instagramUrl,
  youtubeUrl,
  tiktokUrl,
  className = '',
  companyId,
  locale,
}) => {
  const socialLinks = [
    { url: linkedinUrl, icon: LinkedinLogo, label: 'LinkedIn' },
    { url: facebookUrl, icon: FacebookLogo, label: 'Facebook' },
    { url: instagramUrl, icon: InstagramLogo, label: 'Instagram' },
    { url: youtubeUrl, icon: YoutubeLogo, label: 'YouTube' },
    { url: tiktokUrl, icon: TiktokLogo, label: 'TikTok' },
  ].filter(link => link.url);

  if (socialLinks.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {socialLinks.map(({ url, icon: Icon, label }) => (
        <a
          key={label}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center w-10 h-10 rounded-xl border border-jc-border bg-jc-surface text-jc-accent hover:text-jc-cta-hover hover:bg-jc-accent-muted/50 hover:border-jc-accent/30 transition-all hover:scale-105 active:scale-95"
          title={label}
          aria-label={`Visit ${label}`}
          onClick={() => {
            trackCompanyLink({
              companyId: companyId || '',
              locale,
            });
          }}
        >
          <Icon size={18} />
        </a>
      ))}
    </div>
  );
};



